import type { I18nNamespace } from "@/modules/i18n/types"

export const I18N_FOOTER_NAMESPACES: I18nNamespace[] = ["module_footer_fo", "shared_languages", "shared_select_input"]

export const QUERY_CACHE_TIME = 30 * 60 * 1000 // 30 min
export const QUERY_STALE_TIME = 15 * 60 * 1000 // 15 min
